// Redux
import { Result, Action, AsyncResult, ApiAction } from '../../index';
import api from '../../redux-api';
import adminReducer from './admin';

// Types
import { EnterpriseState } from '../types/enterprise';
import { GET_ENTERPRISE_PORTFOLIOS, DELETE_ENTERPRISE_GROUP_PORTFOLIO } from './admin/shared';
import EnterpriseDetails from '@/types/enterprise-detail-info';
import EnterpriseInfos from '@/types/enterprise-infos';
import Enterprise from '@/types/enterprise';
import EnterpriseAdminDetails from '@/types/enterprise-admin-details';

const INITIAL_STATE: EnterpriseState = {
  details: null,
  admin: null,
  loading: false,
};

const SET_DETAILS: Action = {
  type: 'connect/enterprise/set-details',
};

const GET_ADMIN_INFO: ApiAction = {
  type: 'connect/enterprises/get-info',
  endpoint: 'enterprises/:id/',
};

const SAVE_ENTERPRISE_INFO: ApiAction = {
  type: 'connect/enterprises/save-info',
  endpoint: 'enterprises/:id/',
};

// Reducer
export default function reducer(state: EnterpriseState = INITIAL_STATE, action: Action): EnterpriseState {
  switch (action.type) {
    case SET_DETAILS.type: {
      return {
        ...state,
        details: action.details,
      };
    }

    case `${GET_ADMIN_INFO.type}_SUCCESS`: {
      return {
        ...state,
        admin: action.data.enterprise,
      };
    }

    case `${SAVE_ENTERPRISE_INFO.type}_SUCCESS`: {
      return {
        ...state,
        details:
          state.details === null
            ? null
            : {
                ...state.details,
                name: action.data.enterprise.name,
              },
      };
    }

    case `${GET_ENTERPRISE_PORTFOLIOS.type}_SUCCESS`: {
      let { portfolios } = action.data;

      if (action.params.next) {
        const current = (state.details && state.details.portfolios) || [];
        portfolios = current.concat(portfolios);
      }

      return {
        ...state,
        details:
          state.details === null
            ? null
            : {
                ...state.details,
                portfolios,
                nextPortfoliosToken: action.data.next,
              },
      };
    }

    // TODO -- Optimistic UI would be to remove it on action and put it back on FAILURE
    case `${DELETE_ENTERPRISE_GROUP_PORTFOLIO.type}_SUCCESS`: {
      if (!state.details || !state.details.portfolios) {
        return state;
      }

      return {
        ...state,
        details: {
          ...state.details,
          portfolios: state.details.portfolios.filter(p => p._id !== action.data._id),
        },
      };
    }

    // TODO -- This will cause useless re-renders for components connected to this slice
    default: {
      return {
        ...state,
        admin: adminReducer(state.admin, action),
      };
    }
  }
}

export const setEnterpriseDetails =
  (details: EnterpriseDetails): Result<void> =>
  dispatch => {
    dispatch({ ...SET_DETAILS, details });
  };

export const saveEnterpriseInfos =
  (id: string, infos: EnterpriseInfos): AsyncResult<Enterprise> =>
  () =>
    api.patch(SAVE_ENTERPRISE_INFO, { id }, infos);

export const getEnterpriseAdminInfo =
  (id: string): AsyncResult<EnterpriseAdminDetails> =>
  (dispatch, getState) =>
    api.get(GET_ADMIN_INFO, { id });
